import services from 'api/services';
import {
  GET_COURSE_REQUEST,
  GET_COURSE_SUCCESS,
  GET_COURSE_FAILURE,
  UPDATE_FLOW_REQUEST,
  UPDATE_FLOW_SUCCESS,
  UPDATE_FLOW_FAILURE,
  RESET_INPUT_EXERCISE_PROGRESS,
} from './constants';
import { logError } from 'global/errors';

const { CourseService, InputService } = services;

export const getCourse = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_COURSE_REQUEST });
    let course = await CourseService.getCourse(id);
    course.image = course.backgroundImage?.url;
    course.keywords = course.tags;
    delete course.backgroundImage;
    delete course.tags;
    dispatch({ type: GET_COURSE_SUCCESS, course });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_COURSE_FAILURE, error: ex.message });
  }
};

export const updateFlowProgress = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_FLOW_REQUEST });
    let inputExercise = await InputService.updateFlowProgress(body);
    dispatch({ type: UPDATE_FLOW_SUCCESS, inputExercise });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_FLOW_FAILURE, error: ex.message });
  }
};

export const resetInputExerciseProgress = () => async (dispatch) => {
  dispatch({ type: RESET_INPUT_EXERCISE_PROGRESS });
};
